import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const MeasurementType = iotsUtils.fromList(constants.job.volumetrics.measurementTypes);
